// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ChevronDown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChevronDown = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ChevronDown = _exports.ChevronDown = function ChevronDown(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.0114 15.9374C9.72916 15.9374 9.50134 15.8239 9.34246 15.6639L1.84553 8.16434C1.52344 7.83245 1.4364 7.24995 1.84583 6.8402C2.25527 6.43044 2.82343 6.49655 3.17131 6.8402C3.5192 7.18385 10.0104 13.6758 10.0104 13.6758L16.8474 6.83453C17.1662 6.51565 17.7738 6.44348 18.1668 6.83631C18.5044 7.17396 18.5832 7.74944 18.1668 8.1658L10.6666 15.6639C10.5055 15.8239 10.2937 15.9374 10.0114 15.9374Z",
      fill: "#212B36"
    }));
  };
});
